<template>
  <div>
    <alert-modal v-model="isShow" width="90%" :title="'活动规则'">
      <div slot="content">
        <div class="rules">
          <pre class="p-b-15 container">
            {{ ruleDescription }}
          </pre>
        </div>
      </div>
    </alert-modal>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    ruleDescription: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  watch: {
    value(val) {
      this.isShow = val
    },
    isShow(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="less" scoped>
.rules {
  background-color: #ffffff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 20px;
  .container {
    max-height: 350px;
    overflow-y: auto;
    // css保留换行符
    text-align: left;
    line-break: anywhere;
    white-space: pre-line;
    word-break: break-all;
    -webkit-overflow-scrolling: touch;
    /deep/ .van-cell {
      padding: 0;
    }
  }
  p {
    color: #666666;
    font-size: 14px;
    text-align: left;
    line-height: 25px;
    margin-bottom: 15px;
  }
  p:last-child {
    margin-bottom: 0;
  }
}
</style>
